import React from "react";
import Poster from "./poster";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const containerVariants = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.08
    }
  }
};

function RowView({ heading, items }) {
  if (!items || items.length === 0) return null;

  return (
    <div className="container mb-5">
      <div className="row">
        <div className="col-12">
          <div className="section-heading-container">
            <h3 className="text-white section-title m-0">
              {heading}
            </h3>
            <ArrowRight className="section-icon" size={24} />
          </div>
        </div>
        <motion.div
          className="row w-100 m-0"
          variants={containerVariants}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-100px" }}
        >
          {items.slice(0, 12).map((item) => (
            <Poster key={item.id} item={item} />
          ))}
        </motion.div>
      </div>
    </div>
  );
}

export default RowView;
